import SectionLabel from './SectionLabel';

export default SectionLabel;
